// extracted by mini-css-extract-plugin
module.exports = {"Footer":"footer_Footer____J_Q","IconSet":"footer_IconSet__zrC9S","Primary":"footer_Primary__LSCI4","SocalMediaIconSet":"footer_SocalMediaIconSet__E_CZP"};